<template>
  <div class="app-calendar overflow-hidden border">
    <div class="row no-gutters">
      <!-- Sidebar -->
      <div
        class="col app-calendar-sidebar flex-grow-0 overflow-hidden d-flex flex-column"
        :class="{'show': isCalendarOverlaySidebarActive}"
      >
        <calendar-sidebar
          :is-event-handler-sidebar-active.sync="isEventHandlerSidebarActive"
          :area-id.sync="areaId"
          @search-location="searchLocation"
        />
      </div>

      <!-- Calendar -->
      <div class="col position-relative">
        <div class="card shadow-none border-0 mb-0 rounded-0">
          <div class="card-body pb-0">
            <full-calendar
              ref="refCalendar"
              :options="calendarOptions"
              class="full-calendar"
            />
          </div>
        </div>
      </div>
      <manage-shift-sidebar
        v-model="isEventHandlerSidebarActive"
        :event="event"
        @onUpdated="refetchEvents"
      />
    </div>
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import CalendarSidebar from './calendar-sidebar/CalendarSidebar.vue'
import ManageShiftSidebar from './calendar-event-handler/ManageShiftSidebar.vue'
import useCalendar from './useCalendar'

export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    CalendarSidebar,
    ManageShiftSidebar,
  },
  setup() {

    const {
      refCalendar,
      isCalendarOverlaySidebarActive,
      event,
      clearEventData,
      addEvent,
      updateShift,
      createGigAndUpdateShift,
      removeEvent,
      fetchEvents,
      fetchLocationDetails,
      refetchEvents,
      calendarOptions,
      searchUsers,
      sendVerification,
      sendCancelNotification,
      publishShifts,
      // ----- UI ----- //
      isEventHandlerSidebarActive,
      areaId,
      fetchUserUpcomingShifts,
      searchLocation,
    } = useCalendar()
    fetchEvents()

    return {
      refCalendar,
      isCalendarOverlaySidebarActive,
      event,
      clearEventData,
      addEvent,
      updateShift,
      createGigAndUpdateShift,
      removeEvent,
      refetchEvents,
      fetchLocationDetails,
      calendarOptions,
      searchUsers,
      sendVerification,
      sendCancelNotification,
      publishShifts,
      // ----- UI ----- //
      isEventHandlerSidebarActive,
      areaId,
      fetchUserUpcomingShifts,
      searchLocation,
    }
  },
}
</script>

<style lang="scss">
@import "@hw-ui/scss/vue/apps/calendar.scss";
</style>
